import React, { useState } from "react";
import styles from "./styles.module.css";
import FullExport from "../tables/Fullexport";
import ChinaExport from "../tables/Chinatable";
import AgriculturalExport from "../tables/Allagricultural-products";
import AgriculturalProductsChart from "../tables/agricultural-products";
import FullImport from "../tables/Fullimport";
import ChinaImport from "../tables/chinaimport";
import AgriculturalImport from "../tables/AllImportAgricultural";
import ImportAgriculturalProductsChart from "../tables/agricultural-products-import";

export const Activity = () => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  return (
  
     
        <div className={styles.export}>
          <h2>"ВНЕШНЕЭКОНОМИЧЕСКАЯ ДЕЯТЕЛЬНОСТЬ" Экспорт и импорт</h2>
          <h2 className={styles.name_first}>Экспорт</h2>
          <div className={styles.export_inner}>
          <FullExport />
          <ChinaExport />
          <AgriculturalExport/>
          <AgriculturalProductsChart/>
          </div>
          <h2 className={styles.name}>Импорт</h2>
          <div className={styles.import_inner}>
          
            <FullImport/>
            <ChinaImport/>
            <AgriculturalImport/>
            <ImportAgriculturalProductsChart/>
          </div>
        </div>
      

  );
};
